import Exception from './Exception'

function Exception500() {
  return <Exception type="500" />
}

export default Exception500
